import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ContentBody, Section, Icon } from '@lanl-web/lanl-components';

import { JumpToSection } from '../../components';

import './PageSections.scss';

export const PageSections = ({ pageSections, borderTop }) => {
  useEffect(() => {
    const sectionOptions = {
      rootMargin: '-5% 0% -95% 0%',
      threshold: 0,
    };

    jumpToSections.forEach((section) => {
      const sectionToObserve = document.getElementById(section);

      if (sectionToObserve) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const previousActiveSections =
                document.querySelectorAll('.active');

              previousActiveSections?.forEach((previousActiveSection) => {
                previousActiveSection.classList.remove('active');
              });

              const newActiveSection = document.getElementById(
                `selection-${entry.target?.id}`,
              );

              newActiveSection?.classList.add('active');
            }
          });
        }, sectionOptions);

        observer.observe(sectionToObserve);
      }
    });
  });

  const hasGroupings =
    pageSections && pageSections[0]?.group_heading ? true : false;

  const jumpToSections = pageSections?.map((item) =>
    hasGroupings ? item.group_heading : item.section_heading,
  );

  const renderSectionsWithGrouping = () => {
    return (
      <div className='sections-container'>
        {pageSections &&
          pageSections.map(({ group_heading, rl_page_sections }, index) => {
            const categoryClasses = classNames('sections-group', {
              'border-top': !borderTop && index !== 0,
            });

            return (
              <div id={group_heading} key={group_heading}>
                <div className={categoryClasses}>{group_heading}</div>

                {rl_page_sections &&
                  rl_page_sections.map(
                    ({
                      section_heading,
                      add_heading_link,
                      section_heading_link,
                      section_content,
                      tags,
                    }) => {
                      const sectionClasses = classNames(
                        'section',
                        add_heading_link && 'with-link',
                      );
                      return (
                        <div className={sectionClasses} key={section_heading}>
                          {add_heading_link ? (
                            <div className='section-heading'>
                              <a className='link' href={section_heading_link}>
                                {section_heading}{' '}
                                <Icon icon='chevron-right' size='sm' />
                              </a>
                            </div>
                          ) : (
                            <div className='section-heading'>
                              {section_heading}
                            </div>
                          )}

                          {section_content && (
                            <ContentBody
                              className='section-content'
                              body={section_content}
                              isHTML
                            />
                          )}
                          <div className='section-tags-container'>
                            {tags &&
                              tags.map((tag) => {
                                return (
                                  tag.toUpperCase() !== 'NONE' && (
                                    <div className='section-tags' key={tag}>
                                      {tag}
                                    </div>
                                  )
                                );
                              })}
                          </div>
                        </div>
                      );
                    },
                  )}
              </div>
            );
          })}
      </div>
    );
  };

  const renderSections = () => {
    return (
      <div className='sections-container'>
        {pageSections &&
          pageSections.map(({ section_heading, section_content }) => {
            const sectionHeadingClasses = classNames('section', {
              'border-top': borderTop,
            });
            return (
              <div
                id={section_heading}
                className={sectionHeadingClasses}
                key={`${section_heading}-section`}
              >
                <div className='section-heading'>{section_heading}</div>
                {section_content && (
                  <ContentBody body={section_content} isHTML />
                )}
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <Section backgroundColor='white' className='page-sections'>
      <div className='page-sections-and-jumpto-container'>
        {hasGroupings ? renderSectionsWithGrouping() : renderSections()}

        {jumpToSections && (
          <JumpToSection sections={jumpToSections} borderTop={borderTop} />
        )}
      </div>
    </Section>
  );
};

PageSections.defaultProps = {
  borderTop: true,
};

PageSections.propTypes = {
  pageSections: PropTypes.arrayOf(PropTypes.object).isRequired,
  borderTop: PropTypes.bool,
};

export default PageSections;
